import {
  RugbyUnionConversionGoalAttribute,
  RugbyUnionDropGoalAttribute,
  RugbyUnionFoulAttribute,
  RugbyUnionIncidentId,
  RugbyUnionKickAttribute,
  RugbyUnionLineoutAttribute,
  RugbyUnionMaulAttribute,
  RugbyUnionPenaltyKickGoalAttribute,
  RugbyUnionPenaltyTryAttribute,
  RugbyUnionRuckAttribute,
  RugbyUnionScrumAttribute,
  RugbyUnionTackleAttribute,
  RugbyUnionTryAttribute,
  RugbyUnionTurnoverAttribute,
} from '@collector/sportsapi-client-legacy'

import { HistoryIncidentsConfig } from '../../../configuration'

export const historyIncidentsConfig: HistoryIncidentsConfig<RugbyUnionIncidentId> =
  {
    [RugbyUnionIncidentId.Try]: {
      participant: { name: 'Player' },
      attributeIds: [RugbyUnionTryAttribute.Golden],
    },
    [RugbyUnionIncidentId.PenaltyTry]: {
      participant: { name: 'Player' },
      attributeIds: [RugbyUnionPenaltyTryAttribute.Golden],
    },
    [RugbyUnionIncidentId.ConversionGoal]: {
      participant: { name: 'Player' },
      attributeIds: [RugbyUnionConversionGoalAttribute.Golden],
    },
    [RugbyUnionIncidentId.ConversionMissed]: {
      participant: { name: 'Player' },
    },
    [RugbyUnionIncidentId.ConversionAttempt]: {
      participant: { name: 'Player' },
    },
    [RugbyUnionIncidentId.PenaltyKickGoal]: {
      participant: { name: 'Player' },
      attributeIds: [RugbyUnionPenaltyKickGoalAttribute.Golden],
    },
    [RugbyUnionIncidentId.PenaltyKickMissed]: {
      participant: { name: 'Player' },
    },
    [RugbyUnionIncidentId.PenaltyAwarded]: { participant: { name: 'Player' } },
    [RugbyUnionIncidentId.DropGoal]: {
      participant: { name: 'Player' },
      attributeIds: [RugbyUnionDropGoalAttribute.Golden],
    },
    [RugbyUnionIncidentId.DropGoalMissed]: { participant: { name: 'Player' } },
    [RugbyUnionIncidentId.YellowCard]: { participant: { name: 'Player' } },
    [RugbyUnionIncidentId.RedCard]: { participant: { name: 'Player' } },
    [RugbyUnionIncidentId.OrangeCard]: { participant: { name: 'Player' } },
    [RugbyUnionIncidentId.Injury]: { participant: { name: 'Player' } },
    [RugbyUnionIncidentId.SubstitutionIn]: {
      participant: { name: 'Player', required: true },
    },
    [RugbyUnionIncidentId.SubstitutionOut]: {
      participant: { name: 'Player', required: true },
    },
    [RugbyUnionIncidentId.FreeKick]: {},
    [RugbyUnionIncidentId.InPossession]: {},
    [RugbyUnionIncidentId.EntryInto22]: {},
    [RugbyUnionIncidentId.Kick]: {
      attributeIds: [
        RugbyUnionKickAttribute.Pass,
        RugbyUnionKickAttribute.KickForTouch,
        RugbyUnionKickAttribute.Clearance,
        RugbyUnionKickAttribute.RestartKick,
        RugbyUnionKickAttribute.UpAndUnder,
        RugbyUnionKickAttribute.TapKick,
        RugbyUnionKickAttribute.CollectedByOffense,
        RugbyUnionKickAttribute.FiftyTwentyTwoKick,
      ],
    },
    [RugbyUnionIncidentId.GoallineDropout]: {},
    [RugbyUnionIncidentId.Offload]: {},
    [RugbyUnionIncidentId.Turnover]: {
      attributeIds: [
        RugbyUnionTurnoverAttribute.KnockOn,
        RugbyUnionTurnoverAttribute.ForwardPass,
        RugbyUnionTurnoverAttribute.Intercepted,
        RugbyUnionTurnoverAttribute.ForcedIntoTouch,
        RugbyUnionTurnoverAttribute.LostInRuck,
        RugbyUnionTurnoverAttribute.LostInMaul,
        RugbyUnionTurnoverAttribute.LostInScrum,
        RugbyUnionTurnoverAttribute.Offside,
      ],
    },
    [RugbyUnionIncidentId.Foul]: {
      attributeIds: [RugbyUnionFoulAttribute.DangerousPlay],
    },
    [RugbyUnionIncidentId.Ruck]: {
      attributeIds: [RugbyUnionRuckAttribute.Won, RugbyUnionRuckAttribute.Lost],
      singleAttributes: true,
    },
    [RugbyUnionIncidentId.Maul]: {
      attributeIds: [
        RugbyUnionMaulAttribute.Won,
        RugbyUnionMaulAttribute.Lost,
        RugbyUnionMaulAttribute.LeadToTry,
      ],
    },
    [RugbyUnionIncidentId.Scrum]: {
      attributeIds: [
        RugbyUnionScrumAttribute.Won,
        RugbyUnionScrumAttribute.Lost,
      ],
    },
    [RugbyUnionIncidentId.Lineout]: {
      attributeIds: [
        RugbyUnionLineoutAttribute.Won,
        RugbyUnionLineoutAttribute.Lost,
      ],
    },
    [RugbyUnionIncidentId.Tackle]: {
      singleAttributes: false,
      attributeIds: [
        RugbyUnionTackleAttribute.Dominant,
        RugbyUnionTackleAttribute.TrySaving,
      ],
    },
  }
